import React, { FC } from 'react'
import styled from 'styled-components'

import { CarData } from '../../../features/car/types'
import { getProjectName } from '../../../lib/get-project-name'

export const Status: FC<CarData['status']> = ({ color, text }) => {
  return (
    <Wrapper>
      <IconWrapper>
        <Icon color={color} />
      </IconWrapper>
      <Text>{text}</Text>
    </Wrapper>
  )
}

const Wrapper = styled.span`
  display: flex;
  align-items: center;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return '1.2rem'
    return theme.spacing[4]
  }};
  height: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return '1.2rem'
    return theme.spacing[4]
  }};
  text-align: center;
  margin-right: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return '0.8rem'
    return theme.spacing[1]
  }};
`

const Icon = styled.div<{ color?: string }>`
  width: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return '1.2rem'
    return theme.spacing[2]
  }};
  height: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return '1.2rem'
    return theme.spacing[2]
  }};
  display: inline-block;
  border-radius: 50%;

  ${({ color }) => color && `background-color: ${color};`};
`

const Text = styled.div`
  color: ${({ theme }) => {
    if (getProjectName() === 'tank') return theme.palette.white
    if (getProjectName() === 'generic_v2') return theme.palette.grey[600]
    return theme.palette.grey[700]
  }};
  font-size: ${() => {
    return '12px'
  }};

  ${() =>
    getProjectName() === 'generic_v2' &&
    `
      font-size: 14px;
      
      @media screen and (max-width: 768px) {
        font-size: 12px;
      }
    `}
`
